var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-switcher"},[_c('ejs-dropdownlist',{attrs:{"enabled":false,"id":"localeDropdownList","dataSource":_vm.locales,"index":_vm.localeIndex,"fields":_vm.fields,"change":_vm.onChange,"placeholder":_vm.dropdownPlaceholder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }